import { render } from "./ImageRenderer.vue?vue&type=template&id=67030bda&scoped=true"
import script from "./ImageRenderer.vue?vue&type=script&lang=js"
export * from "./ImageRenderer.vue?vue&type=script&lang=js"

import "./ImageRenderer.vue?vue&type=style&index=0&id=67030bda&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67030bda"]])

export default __exports__